import { ActivityRepositoryInterface } from "@/data/persistences/repositories/contracts/ActivityRepositoryInterface";
import { SendActivityApiRequest } from '@/data/payload/api/ActivityApiRequest';
import { injectable } from 'tsyringe';
import { ActivityApiRepository } from '@/app/infrastructures/repositories/api/ActivityApiRepository';

@injectable()
export class ActivityPresenter implements ActivityRepositoryInterface {
  private repository: ActivityApiRepository;

  constructor(repository: ActivityApiRepository) {
    this.repository = repository;
  }

  sendActivity(payload: SendActivityApiRequest): Promise<boolean> {
    return this.repository.sendActivity(payload);
  }
}

